<script setup lang="ts">
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';
import PtwBackButton from '@/components/buttons/PtwBackButton.vue';
import JobConfigurationForm from './components/JobConfigurationForm.vue';
import { useVeeForm } from '@/components/forms/useVeeForm';
import { api } from '@/api';
import { routenames } from '@/router/routenames';
import { onMounted } from 'vue';
import { useLoading } from '@/utils/useLoading';
import BasePageStatus from '@/components/pages/BasePage/BasePageStatus.vue';
import { JobConfigurationDto } from '@/api/generator';
import { entityNotFoundErrorHandler } from '@/errorHandling';
import { useRouter } from 'vue-router';

interface JobDetailsViewProps {
  id: string;
}

const props = defineProps<JobDetailsViewProps>();

const router = useRouter();

const { action: loadJob, loading } = useLoading(async () => {
  const { result, success } = await api.jobConfigurationsApi.getJobConfiguration(
    {
      id: props.id,
    },
    [entityNotFoundErrorHandler(router)],
  );

  if (success && result) {
    resetForm({ values: result });
  }
}, true);

const {
  form: { resetForm, values },
} = useVeeForm<JobConfigurationDto>({
  mode: 'details',
});

onMounted(loadJob);
</script>

<template>
  <BasePage :loading="loading">
    <template #title>
      <BasePageTitle
        :subtitle="`${$t('JobConfiguration_one')}${values?.targetSystem?.name ? ' | ' + values.targetSystem.name : ''}`"
        :title="values.name"
        :titleId="values.iuid"
      />
    </template>

    <template #status>
      <BasePageStatus :entity="values" />
    </template>

    <template #actions>
      <PtwBackButton :to="{ name: routenames.jobConfigurations.overview }" />
    </template>

    <JobConfigurationForm />
  </BasePage>
</template>
